import map from 'lodash/map';
import {
  GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_START,
  GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_SUCCESS,
  CLEAR_SUBSCRIPTION,
  GET_SUBSCRIPTION_FORM_START,
  GET_SUBSCRIPTION_FORM_SUCCESS,
} from 'actions/subscriptions';
import { buildOptionsFromPaths } from 'utils/hierarchy/general';
import { PropertyType } from 'xm-constants/subscriptions';

export const defaultState = {
  loading: false,
  userSubscription: {
    loading: true,
    data: null,
  },
  subscriptionForm: {
    loading: true,
    data: null,
  },
};

const getOptions = propertyDefinition => {
  const { propertyType, items, paths } = propertyDefinition;

  if (propertyType === PropertyType.HIERARCHY) {
    return buildOptionsFromPaths(paths);
  }
  return map(items, value => ({ value }));
};

const buildCriteria = propertyDefinitions =>
  map(propertyDefinitions, propertyDef => ({
    type: propertyDef.propertyType,
    name: propertyDef.name,
    options: getOptions(propertyDef),
    comparator: '',
  }));

export default function subscriptions(state = defaultState, action) {
  switch (action.type) {
    case GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_START: {
      return {
        ...state,
        userSubscription: {
          loading: true,
          data: null,
        },
      };
    }
    case GET_SUBSCRIPTION_AND_ALL_SUBSCRIBERS_SUCCESS: {
      return {
        ...state,
        userSubscription: {
          loading: false,
          data: action.payload,
        },
      };
    }
    case CLEAR_SUBSCRIPTION: {
      return {
        ...state,
        userSubscription: defaultState.userSubscription,
      };
    }
    case GET_SUBSCRIPTION_FORM_START: {
      return {
        ...state,
        subscriptionForm: {
          loading: true,
          data: null,
        },
      };
    }
    case GET_SUBSCRIPTION_FORM_SUCCESS: {
      return {
        ...state,
        subscriptionForm: {
          loading: false,
          data: {
            ...action.payload,
            propertyDefinitions: action.payload.propertyDefinitions.data,
            criteria: buildCriteria(action.payload.propertyDefinitions.data),
          },
        },
      };
    }
    default: {
      return state;
    }
  }
}
